// extracted by mini-css-extract-plugin
export default {"Link":"NavBar_Link__M-QDj"};